import { HEALTHY_CONTACT_FORM_URL } from "@/data/certificateBookingActions";
import { cn } from "@/lib/utils";

type HealthyContactEmbedProps = {
  src?: string;
  title?: string;
  className?: string;
  iframeClassName?: string;
};

export const HealthyContactEmbed = ({
  src = HEALTHY_CONTACT_FORM_URL,
  title = "Contact form",
  className,
  iframeClassName = "h-[70vh] min-h-[640px] w-full border-0",
}: HealthyContactEmbedProps) => (
  <div className={cn(className)}>
    <iframe
      src={src}
      title={title}
      className={iframeClassName}
      style={{ width: "100%" }}
      loading="lazy"
      allow="clipboard-write"
    />
  </div>
);

export { HEALTHY_CONTACT_FORM_URL };
